import Model from './BaseModel'

export default class CancellationRequisition extends Model {
    resourceName() {
        return 'cancellationRequisitions'
    }

    fields() {
        return ['customer_id', 'manager_id', 'reason', 'retained']
    }
}
